<div class="ai-empty">
  <div class="ai-empty__icon"><i class="pi pi-sparkles"></i></div>
  <h4 class="ai-empty__title">
    <ng-container *ngIf="greeting">{{ greeting }} </ng-container>{{ prompt }}
  </h4>
  <p class="ai-empty__sub" *ngIf="!typing">
    Ask Remmi a question or describe what you’d like to do. Use your keyboard or microphone. Any changes will be confirmed before they are applied.
  </p>

  <div class="ai-empty__day" *ngIf="day">
    <button type="button" class="ai-empty__day-chip" *ngIf="day.follow_ups_today" (click)="ask.emit('Show my follow-ups due today')">
      <i class="pi pi-bell"></i> {{ day.follow_ups_today }} due today
    </button>
    <button
      type="button"
      class="ai-empty__day-chip ai-empty__day-chip--warn"
      *ngIf="day.follow_ups_overdue"
      (click)="ask.emit('Show my overdue follow-ups')">
      <i class="pi pi-exclamation-circle"></i> {{ day.follow_ups_overdue }} overdue
    </button>
    <button type="button" class="ai-empty__day-chip" *ngIf="day.new_leads_today" (click)="ask.emit('Show my new leads today')">
      <i class="pi pi-user-plus"></i> {{ day.new_leads_today }} new
    </button>
    <button type="button" class="ai-empty__day-chip" *ngIf="day.appointments_today" (click)="ask.emit('Show my appointments today')">
      <i class="pi pi-calendar"></i> {{ day.appointments_today }} appointment{{ day.appointments_today === 1 ? '' : 's' }}
    </button>
    <button type="button" class="ai-empty__day-chip" *ngIf="day.inspections_today" (click)="ask.emit('Show my inspections today')">
      <i class="pi pi-search"></i> {{ day.inspections_today }} inspection{{ day.inspections_today === 1 ? '' : 's' }}
    </button>
  </div>

  <button type="button" class="ai-empty__cta" (click)="ask.emit('Tell me about my day')">
    <i class="pi pi-sun"></i>
    <span>Tell me about my day</span>
  </button>

  <div class="ai-empty__chips">
    <button type="button" class="ai-empty__chip" *ngFor="let s of suggestions" (click)="ask.emit(s.prompt)">
      <i class="pi" [ngClass]="iconClass(s.icon)"></i>
      <span>{{ s.label }}</span>
    </button>
  </div>

  <!-- "What can I do?" discovery (FRONTEND_HANDOFF §8) -->
  <button type="button" class="ai-empty__more" [class.is-open]="showCapabilities" (click)="toggleCapabilities()">
    <i class="pi pi-question-circle"></i>
    <span>What can I do?</span>
    <i class="pi" [ngClass]="showCapabilities ? 'pi-angle-up' : 'pi-angle-down'"></i>
  </button>

  <div class="ai-caps" *ngIf="showCapabilities && capabilities.length">
    <div class="ai-cap" *ngFor="let cat of capabilities" [class.ai-cap--off]="!cat.available">
      <div class="ai-cap__head">
        <strong>{{ cat.category }}</strong>
        <span class="ai-cap__badge" *ngIf="!cat.available">Coming soon</span>
      </div>
      <div class="ai-cap__examples" *ngIf="cat.available && cat.examples?.length">
        <button type="button" class="ai-cap__example" *ngFor="let ex of cat.examples" (click)="ask.emit(ex)">{{ ex }}</button>
      </div>
    </div>
  </div>
</div>
